// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, verifyEmailVerificationCode } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitVerifyEmailVerificationCode = createAsyncThunk(
  "hitVerifyEmailVerificationCode",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + verifyEmailVerificationCode;
      const response = await axios.put(url, payload, config);
      return response.data;
    } catch (error) {
      showToast(error.response.data.message, "error");
      throw error.response.data;
    }
  }
);

const EmailVerifyCodeSlice = createSlice({
  name: "emailVerifyCodeReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearEmailVerifyCodeData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitVerifyEmailVerificationCode.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitVerifyEmailVerificationCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        // ✅ Save token to localStorage when login is successful
       
        if (action.payload?.status == true && action.payload?.data?.accessToken) {
          if(action.payload?.type == 1){             
          localStorage.setItem("professionalToken", action.payload.data.accessToken);
          localStorage.setItem("professionalId", action.payload.data._id);
          localStorage.setItem("professionalData", JSON.stringify(action.payload.data));
          }
          else{
            localStorage.setItem("clientId", action.payload.data._id);
            localStorage.setItem("clientData", JSON.stringify(action.payload.data));
            localStorage.setItem("clientToken", action.payload.data.accessToken);
          }
        }
      })
      .addCase(hitVerifyEmailVerificationCode.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearEmailVerifyCodeData } = EmailVerifyCodeSlice.actions;
export default EmailVerifyCodeSlice.reducer;
